(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blendy-safety-alarm"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript&&document.currentScript.closest?document:document;
  document.querySelectorAll('.bsa-q button').forEach(function(b){
    b.addEventListener('click',function(){
      var q=b.parentElement;
      document.querySelectorAll('.bsa-q').forEach(function(x){if(x!==q)x.classList.remove('open');});
      q.classList.toggle('open');
    });
  });
  var gm=document.getElementById('bsaGalMain');
  document.querySelectorAll('.bsa-gal-thumbs img').forEach(function(t){
    t.addEventListener('click',function(){
      if(gm)gm.src=t.getAttribute('data-full')||t.src;
      document.querySelectorAll('.bsa-gal-thumbs img').forEach(function(x){x.classList.remove('active');});
      t.classList.add('active');
    });
  });
  var sb=document.getElementById('bsaSticky');
  var hero=document.querySelector('.bsa-hero');
  var fin=document.querySelector('.bsa-final');
  window.addEventListener('scroll',function(){
    if(!sb||!hero||!fin)return;
    var past=window.scrollY>(hero.offsetHeight*0.9);
    var atFin=fin.getBoundingClientRect().top<window.innerHeight;
    sb.classList.toggle('show',past&&!atFin);
  });
  // ===== הדגמת צליל אזעקה (יזום ע"י המשתמש; אוטופליי עם קול חסום בדפדפנים) =====
  var demoBtn=document.getElementById('bsaDemo');
  var beacon=document.querySelector('.bsa-beacon');
  var hint=document.getElementById('bsaDemoHint');
  var urlEl=document.getElementById('bsaSoundUrl');
  var soundUrl=urlEl?urlEl.value.trim():'';
  var playing=false,actx=null,audioEl=null,stopT=null;
  function stopDemo(){
    playing=false;
    if(beacon)beacon.classList.remove('playing');
    if(hint)hint.textContent='🔊 הקישי להדגמת הצליל';
    if(audioEl){try{audioEl.pause();audioEl.currentTime=0;}catch(e){}audioEl=null;}
    if(actx){try{actx.close();}catch(e){}actx=null;}
    if(stopT){clearTimeout(stopT);stopT=null;}
  }
  function playDemo(){
    if(playing){stopDemo();return;}
    playing=true;
    if(beacon)beacon.classList.add('playing');
    if(hint)hint.textContent='⏹ עצרי';
    if(soundUrl){
      audioEl=new Audio(soundUrl);audioEl.volume=0.6;
      audioEl.play().catch(function(){});
      audioEl.onended=stopDemo;stopT=setTimeout(stopDemo,5000);return;
    }
    try{
      var AC=window.AudioContext||window.webkitAudioContext;actx=new AC();
      var osc=actx.createOscillator(),gain=actx.createGain(),lfo=actx.createOscillator(),lfoGain=actx.createGain();
      osc.type='square';osc.frequency.value=820;
      lfo.type='sine';lfo.frequency.value=4.5;lfoGain.gain.value=420;
      lfo.connect(lfoGain);lfoGain.connect(osc.frequency);
      var t=actx.currentTime,dur=3.5;
      gain.gain.setValueAtTime(0.0001,t);
      gain.gain.exponentialRampToValueAtTime(0.16,t+0.15);
      gain.gain.setValueAtTime(0.16,t+dur-0.3);
      gain.gain.exponentialRampToValueAtTime(0.0001,t+dur);
      osc.connect(gain);gain.connect(actx.destination);
      osc.start();lfo.start();
      stopT=setTimeout(stopDemo,dur*1000+60);
    }catch(e){stopDemo();}
  }
  if(demoBtn)demoBtn.addEventListener('click',playDemo);
  // ===== וידאו 9:16 — אוטופליי מושתק כשנכנס לתצוגה + כפתור קול =====
  var vid=document.getElementById('bsaVideo');
  var unmute=document.getElementById('bsaUnmute');
  if(vid){
    var vio=new IntersectionObserver(function(es){es.forEach(function(e){
      if(e.isIntersecting){vid.play().catch(function(){});}else{vid.pause();}
    });},{threshold:0.4});
    vio.observe(vid);
    if(unmute){unmute.addEventListener('click',function(){
      vid.muted=!vid.muted;
      if(!vid.muted){vid.play().catch(function(){});unmute.textContent='🔊 קול פעיל';}
      else{unmute.textContent='🔇 הקישי לקול';}
    });}
  }
  // ===== בחירת באנדל (כמות) =====
  var bundles=document.querySelectorAll('.bsa-bundle');
  var qtyInput=document.getElementById('bsaQty');
  var ctaTotal=document.getElementById('bsaCtaTotal');
  var stickyPrice=document.getElementById('bsaStickyPrice');
  function selectBundle(el){
    bundles.forEach(function(b){b.classList.remove('selected');var r=b.querySelector('input');if(r)r.checked=false;});
    el.classList.add('selected');
    var r=el.querySelector('input');if(r)r.checked=true;
    if(qtyInput)qtyInput.value=el.getAttribute('data-qty');
    var fmt=el.getAttribute('data-total-fmt');
    if(ctaTotal&&fmt)ctaTotal.textContent=fmt;
    if(stickyPrice&&fmt)stickyPrice.textContent=fmt;
  }
  if(bundles.length){
    bundles.forEach(function(el){el.addEventListener('click',function(){selectBundle(el);});});
    selectBundle(bundles[0]);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
